import {
  ManagedTeams,
  ManagedTeamsOld,
  SeniorityLevel,
} from '~/lib/talentProfileEnums'

export default {
  seniorityLevel: {
    [SeniorityLevel.None]: 'Nicht nötig',
    [SeniorityLevel.Junior]: '1-2 Jahre',
    [SeniorityLevel.MidLevel]: '3-5 Jahre',
    [SeniorityLevel.Senior]: '5+ Jahre',
    [SeniorityLevel.Principal]: '10+ Jahre',
  },
  managedTeams: {
    [ManagedTeams.SalesReps]: 'Sales Development Representative Team',
    [ManagedTeams.AccountExecutives]: 'Account Executive Team',
    [ManagedTeams.AccountManagers]: 'Account Manager Team',
    [ManagedTeams.WholeDepartment]: 'Gesamte Abteilung',
    [ManagedTeams.Other]: 'Andere',
    [ManagedTeamsOld.SalesReps]: 'Sales Development Representative Team',
    [ManagedTeamsOld.AccountExecutives]: 'Account Executive Team',
    [ManagedTeamsOld.AccountManagers]: 'Account Manager Team',
    [ManagedTeamsOld.WholeDepartment]: 'Gesamte Abteilung',
  },
}